import { useState } from 'react';

import { Line1, Line2, Line3, Wrapper } from './Hamburger.styles';

interface HamburgerProps {
  onClick?: (boolean) => void;
}

const Hamburger = ({ onClick = () => null }: HamburgerProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOnClick = () => {
    onClick(!isOpen);
    setIsOpen(!isOpen);
  };

  return (
    <Wrapper onClick={handleOnClick}>
      <Line1 isOpen={isOpen} />
      <Line2 isOpen={isOpen} />
      <Line3 isOpen={isOpen} />
    </Wrapper>
  );
};

export default Hamburger;
